import { calendarDates as Props } from "../../../types/calendar";
import DataCell from "../DataCell";
import { Wrapper } from "./CalendarDays.components";

const CalendarDays: React.FC<Props> = ({ thisMonthNow, calendarDates, selectedDay, setSelectedDay }) => {
  return (
    <Wrapper>
      {calendarDates.map((day: any) => {
        return (
          <DataCell
            setSelectedDay={setSelectedDay}
            selectedDay={selectedDay}
            key={`${day.date}${day.month}`}
            day={day}
            thisMonthNow={thisMonthNow}
          />
        );
      })}
    </Wrapper>
  );
};

export default CalendarDays;
